export default __webpack_public_path__ + "static/media/skrap-logo-black-h.f8e5656c.svg";